import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";


export interface Props {
    value: number;
    onChange: (x: number) => void;
}

export class TarifaCell extends React.PureComponent<Props> {
    render() {
        const props = this.props;
        return <kea.Number value={this.props.value} onChange={this.props.onChange} format="currency" />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/edit/componentes/valores/cell.tsx